import { useMemo } from 'react'
import { useGetCourseChaptersQuery } from '@services/courseChapters'
import { PER_PAGE } from '@const/pagination'
import useItemsFilters, { FilterState } from './useItemsFilters'

const useCourseChapters = (
  initFilters: FilterState = {},
  pagination = true,
  limit = PER_PAGE
) => {
  const { filters, setFilters, setPage, page } = useItemsFilters(
    initFilters,
    pagination,
    limit
  )

  const state = useGetCourseChaptersQuery(filters, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: false,
    refetchOnReconnect: false,
  })

  const sortedData = useMemo(() => {
    if (!state.data) {
      return state.data
    }

    return {
      ...state.data,
      items: [...state.data.items].sort((a, b) => {
        if (a.sortOrder === b.sortOrder) {
          return a.id - b.id
        }

        return a.sortOrder - b.sortOrder
      }),
    }
  }, [state.data])

  return {
    ...state,
    data: sortedData,
    page,
    setPage,
    setFilters,
  }
}

export default useCourseChapters
